module.exports = __webpack_public_path__ + "img/Frame 1143three2.ab251365.png";